import {
  AnimalSize,
  PetType,
  PetCharacteristic,
  SupportedLanguage,
  Currency,
} from './animalHeaven.types';

export const ADD_LOCATION_TO_STACK = 'ADD_LOCATION_TO_STACK';
export const LOGOUT = 'LOGOUT';
export const SET_ANIMAL_SIZES = 'SET_ANIMAL_SIZES';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_GIF_TO_SHOW = 'SET_GIF_TO_SHOW';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LOADING = 'SET_LOADING';
export const SET_PET_CHARACTERISTIC = 'SET_PET_CHARACTERISTIC';
export const SET_PET_TYPES = 'SET_PET_TYPES';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_HAS_ADOPTION_CENTER = 'SET_USER_HAS_ADOPTION_CENTER';
export const UPDATE_USER = 'UPDATE_USER';

export interface SetToken {
  type: typeof SET_TOKEN;
  payload: { token: string };
}

export interface Logout {
  type: typeof LOGOUT;
  payload: {};
}

export interface SetInitialState {
  type: typeof SET_INITIAL_STATE;
  payload: {
    email: string;
    firstName: string;
    id: string;
    isAdmin: boolean;
    language: SupportedLanguage;
    lastName: string;
    phone: string;
    phoneCode: string;
    hasAdoptionCenter: boolean;
  };
}

export interface SetUserHasAdotionCenter {
  type: typeof SET_USER_HAS_ADOPTION_CENTER;
  payload: { hasAdoptionCenter: boolean };
}

export interface UpdateUser {
  type: typeof UPDATE_USER;
  payload: {
    firstName: string;
    language: SupportedLanguage;
    lastName: string;
    phone: string;
    phoneCode: string;
  };
}

export interface SetPetTypes {
  type: typeof SET_PET_TYPES;
  payload: {
    petTypes: PetType[];
  };
}

export interface SetLoading {
  type: typeof SET_LOADING;
  payload: { key: 'petTypes' | 'animalSizes' | 'petCharacteristics'; value: boolean };
}

export interface SetGifToShow {
  type: typeof SET_GIF_TO_SHOW;
  payload: { gifName: string };
}

export interface SetAnimalSizes {
  type: typeof SET_ANIMAL_SIZES;
  payload: {
    animalSizes: AnimalSize[];
  };
}

export interface AddLocationToStack {
  type: typeof ADD_LOCATION_TO_STACK;
  payload: {
    location: string;
  };
}

export interface SetPetCharacteristics {
  type: typeof SET_PET_CHARACTERISTIC;
  payload: {
    petCharacteristics: PetCharacteristic[];
  };
}

export interface SetCurrency {
  type: typeof SET_CURRENCY;
  payload: {
    currency: Currency;
  };
}

export type AnimalHeavenActionType =
  | AddLocationToStack
  | Logout
  | SetAnimalSizes
  | SetCurrency
  | SetGifToShow
  | SetInitialState
  | SetLoading
  | SetPetTypes
  | SetPetCharacteristics
  | SetToken
  | SetUserHasAdotionCenter
  | UpdateUser;
